import Runtime from 'react/jsx-dev-runtime';

import { compat } from './jsx-runtime';

export const jsxDEV = compat.bind(Runtime.jsxDEV);

export { type JSX } from './jsx-runtime';
export { Fragment } from "react";
